const deleteQuestionsStr = {
  toastrTrue: 'Grupo deletado',
  toastrFalse: 'Questão deletada',
  txt: 'deletado com sucesso'
};

export default deleteQuestionsStr;
